/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */
/* Project Import will be here */
import StatusCodeListComponent from './statusCodeList.component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/login.Action';

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class StatusCodeListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statusCodeDataList: [],
            isOpenModel: false,
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            selectedValue: {},
            isEditStatusCode: false,
            statusCodeSearchText: "",
            isSetButtonDisabled: false,
            isDeleteConfirm: false,
            selectedIdForDelete: ""
        };
    }

    componentDidMount() {
        this.getStatusCodeList();
    }

    getStatusCodeById(statusCodeId) {
        let { selectedValue } = this.state;
        let url = `${ApiUrls.Routes.FLDSTSCD_C}${ApiUrls.Routes.GT_STSCD_M}?statusCodeId=${statusCodeId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                selectedValue = responseData.data;
                this.setState({
                    selectedValue, isEditStatusCode: true
                });
            }
        });
    }

    getStatusCodeList() {
        let { statusCodeSearchText, pagination } = this.state;
        let searchArray = [];
        if (statusCodeSearchText) {
            let searchObj = {
                FieldName: Constants.STATUS_CODE_SEARCH_TEXT,
                Value: statusCodeSearchText
            };
            searchArray.push(searchObj);
        };
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.FLDSTSCD_C}${ApiUrls.Routes.GT_A_FSCDLT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                this.setState({
                    statusCodeDataList: responseData.data,
                    pagination
                });
            }
            else {
                this.setState({
                    statusCodeDataList: []
                });
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getStatusCodeList();
        });
    }

    onStatusCodeSearch = event => {
        this.setState({ statusCodeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getStatusCodeList();
        });
    }

    handleStatusCodeChange = (e, { name, value }) => {
        let { selectedValue } = this.state;
        selectedValue[name] = value;
        this.setState({ selectedValue });
    }
    onOpenModel = statusCodeListDetails => {
        this.setState({
            isOpenModel: true,
            isSetButtonDisabled: false,
            selectedValue: {}
        }, () => {
            if (statusCodeListDetails.statusCodeId) {
                this.getStatusCodeById(statusCodeListDetails.statusCodeId);
            }
        });
    }

    onCloseModel = () => {
        this.setState({ isOpenModel: false, isEditStatusCode: false, selectedValue: {} }, () => this.getStatusCodeList());
    }

    onSaveStatusCode(statusCodeId = null) {
        let { selectedValue, isEditStatusCode } = this.state;
        this.setState({ isSetButtonDisabled: true });
        if (!selectedValue.statusInitial || !selectedValue.statusInitial.trim()) {
            MessageBox(Constants.PLEASE_ENTER_STATUS_CODE, Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            return;
        }
        if (!selectedValue.displayText || !selectedValue.displayText.trim()) {
            MessageBox(Constants.PLEASE_ENTER_STATUS_CODE, Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            return;
        }
        let requestData = {};
        requestData = {
            ID: selectedValue.id,
            StatusInitial: selectedValue.statusInitial.trim(),
            DisplayText: selectedValue.displayText.trim(),
            IsActive: selectedValue.isActive
        }
        let url = `${ApiUrls.Routes.FLDSTSCD_C}${ApiUrls.Routes.SV_STSCD_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            if (responseData.success) {
                this.onCloseModel();
            }
        });
    }

    onClickDelete = (statusCodeListDetails) => {
        this.setState({ isDeleteConfirm: true, selectedIdForDelete: statusCodeListDetails.statusCodeId });
    }
    onCancelDelete = () => {
        this.setState({ isDeleteConfirm: false, selectedValue: {} });
    }
    onConfirmDelete = () => {
        let { selectedIdForDelete } = this.state;
        let url = `${ApiUrls.Routes.FLDSTSCD_C}${ApiUrls.Routes.DLT_STSCD_M}?statusCodeId=${selectedIdForDelete}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                this.setState({ isDeleteConfirm: false, selectedValue: {} }, () => {
                    var apage = Math.ceil((this.state.pagination.totalRecordCount - 1) / Constants.DEFAULT_TAKE);
                    this.onPageChange(null, { activePage: this.state.pagination.activePage > apage ? apage : this.state.pagination.activePage });
                });
            }
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
        });
    }

    render() {
        const { statusCodeDataList, isEditStatusCode, isSetButtonDisabled, groupAccess,
            Division, selectedValue, group, isOpenModel, pagination, isDeleteConfirm } = this.state;
        return (
            <Fragment>
                <StatusCodeListComponent
                    {...{
                        statusCodeList: {
                            statusCodeDataList,
                            isOpenModel,
                            pagination,
                            groupAccess,
                            Division,
                            group,
                            selectedValue,
                            isEditStatusCode,
                            isSetButtonDisabled,
                            isDeleteConfirm
                        }
                    }}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onSaveStatusCode={this.onSaveStatusCode.bind(this)}
                    onStatusCodeSearch={this.onStatusCodeSearch.bind(this)}
                    handleStatusCodeChange={this.handleStatusCodeChange.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    user={this.props.user}
                    onCancelDelete={this.onCancelDelete.bind(this)}
                    onClickDelete={this.onClickDelete.bind(this)}
                    onConfirmDelete={this.onConfirmDelete.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatusCodeListPage));
StatusCodeListPage.displayName = 'StatusCodeListPage';